<ns-dialog-content>
    <nes-heading tag="h1" size="3xl" class="nes-mb-3">
        {{ 'USER_DATA.FACE_IMAGE.TITLE' | translate }}
      </nes-heading>

    <div
        class="result-container"
        *ngIf="image">
        <div>
            <div
                class="image-container"
                privacySensitive>
                <!-- alt="" to skip reading this image by screenreaders -->
                <img alt="" [src]="image.imageAsBase64 | displayImage">
            </div>
        </div>
        <div class="agreement-container">
            <p>
                <i class="icon icon--inline icon--check"></i>
                {{ 'USER_DATA.FACE_IMAGE.ACCEPTED' | translate }}
            </p>
            <div
                class="checkbox nes-flex nes-align-top nes-mt-5"
                [cypress]="'check_disclaimer'">
                <input
                    (click)="checked.emit(!image.authorizedSavePermission)"
                    [checked]="image.authorizedSavePermission"
                    type="checkbox"
                    class="nes-h-6 nes-w-6 nes-mr-5"
                    id="disclamer">
                <label
                    class="checkbox__label checkbox__label--disclamer nes-pl-0"
                    for="disclamer"
                    tabindex="-1">
                    {{ 'USER_DATA.FACE_IMAGE.AGREEMENT' | translate }}
                    <bca-tool-tip [textOrKey]="'USER_DATA.FACE_IMAGE.TOOLTIP'"></bca-tool-tip>
                </label>
            </div>
        </div>
    </div>

    <ng-container *ngIf="metrics">
        <p class="inlineNotification inlineNotification--alert">
            <i class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"></i>
            <span class="inlineNotification__text">
                {{ 'USER_DATA.FACE_IMAGE.DECLINED' | translate }}
            </span>
        </p>
        <div class="richText">
            <ul>
                <li *ngFor="let metric of metrics">
                    {{ metric.metricMessage ? metric.metricMessage : 'USER_DATA.FACE_IMAGE.DEFAULT_METRIC' | translate }}
                </li>
            </ul>
        </div>
    </ng-container>
</ns-dialog-content>
<ns-dialog-actions>
    <nes-button
        (click)="choose.emit()"
        [cypress]="'dialog_decline'"
        type="button"
        variant="tertiary">
        {{ 'USER_DATA.BUTTON.MAKE_PHOTO_NEW' | translate }}
    </nes-button>
    <nes-button *ngIf="image != null && image.imageAsBase64 != null"
        (click)="save.emit()"
        [cypress]="'dialog_accept'"
        variant="primary"
        type="button"
        class="mb-2">
        {{ 'USER_DATA.BUTTON.SAVE' | translate }}
    </nes-button>
</ns-dialog-actions>
